import {
  PAGE_SIZE,
  ERROR_SKIP_WAITING_TIME,
  ROUTE_URLS,
  WORKFLOW_STEP_DEFAULT_HANDLER_TEAMS,
  DELAY_REFRESH_TIME
} from './consts';

export default {
  'PAGE_SIZE': PAGE_SIZE,
  'ERROR_SKIP_WAITING_TIME': ERROR_SKIP_WAITING_TIME,
  'ROUTE_URLS': ROUTE_URLS,
  'WORKFLOW_STEP_DEFAULT_HANDLER_TEAMS': WORKFLOW_STEP_DEFAULT_HANDLER_TEAMS,
  'DELAY_REFRESH_TIME': DELAY_REFRESH_TIME
};